import { ColumnOption } from '../components/ColumnPicker';

export const sortColumnsByOrder = (x: ColumnOption, y: ColumnOption) =>
    sort(x.order, y.order);

export const sortColumnsByName = (x: ColumnOption, y: ColumnOption) =>
    sort(x.name, y.name);

const sort = (x: any, y: any) => {
    if (x > y) {
        return 1;
    } else if (x < y) {
        return -1;
    } else {
        return 0;
    }
};
